// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1772700908943
      var cssReload = require("E:/xc/integrated-business-and-finance-wechat/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  